import { createBrowserHistory } from 'history';

const history = createBrowserHistory({});

export default history;

const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
